import accessLogsReducers from 'reduxStore/accessLogs/slice';
import AppReducer from 'reduxStore/app/slice';
import AuthReducers from 'reduxStore/auth/slice';
import bookingReducers from 'reduxStore/bookings/slice';
import DefaultSettingsReducers from 'reduxStore/defaultSettings/slice';
import RemoteConfigReducers from 'reduxStore/fbRemoteConfig/slice';
import lockersLogsReducers from 'reduxStore/lockersLogs/slice';
import OrganisationReducers from 'reduxStore/organisations/slice';
import SettingsReducers from 'reduxStore/settings/slice';
import sitesReducers from 'reduxStore/sites/slice';

import AssetGroupReducers from 'reduxStore/assetGroups/slice';
import CategoriesReducers from 'reduxStore/categories/slice';
import CredentialsReducers from 'reduxStore/credentials/slice';
import DefaultCategoriesReducers from 'reduxStore/defaultCategories/slice';
import DevicesReducers from 'reduxStore/devices/slice';
import FloorsReducers from 'reduxStore/floors/slice';
import InventoryReducers from 'reduxStore/inventory/slice';
import maintenanceReducers from 'reduxStore/maintenance/slice';
import MapsReducers from 'reduxStore/maps/slice';
import PeopleReducers from 'reduxStore/people/slice';
import permissionReducers from 'reduxStore/permissions/slice';
import RolesReducers from 'reduxStore/roles/slice';
import TeamsReducers from 'reduxStore/teams/slice';
import TypesReducers from 'reduxStore/types/slice';
import InnerRangeReducers from 'reduxStore/innerRange/slice';
import ControlReducers from 'reduxStore/control/slice';

const reducers = {
	// all the reducers will be here
	AccessLogs: accessLogsReducers,
	App: AppReducer,
	AssetGroups: AssetGroupReducers,
	Auth: AuthReducers,
	Bookings: bookingReducers,
	DefaultSettings: DefaultSettingsReducers,
	DefaultCategories: DefaultCategoriesReducers,
	Devices: DevicesReducers,
	FbRemoteConfig: RemoteConfigReducers,
	Floors: FloorsReducers,
	LockersLogs: lockersLogsReducers,
	Maintenance: maintenanceReducers,
	People: PeopleReducers,
	Settings: SettingsReducers,
	Sites: sitesReducers,
	Teams: TeamsReducers,
	Types: TypesReducers,
	Organisations: OrganisationReducers,
	Categories: CategoriesReducers,
	Inventory: InventoryReducers,
	Credentials: CredentialsReducers,
	Permissions: permissionReducers,
	Maps: MapsReducers,
	Roles: RolesReducers,
	InnerRange: InnerRangeReducers,
	Control: ControlReducers
};

export default reducers;
